import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { LoadingOverlayService } from '@app/services';

@Component({
  selector: 'app-loading-overlay',
  templateUrl: './loading-overlay.component.html',
  styleUrls: ['./loading-overlay.component.scss'],
  standalone: false
})
export class LoadingOverlayComponent implements OnInit {
  @Input() label: string;
  @Input() centered: boolean = false;

  iconHtml: SafeHtml;
  iconLabel: string;

  constructor(
    private _loadingService: LoadingOverlayService,
    private _sanitizer: DomSanitizer,
    private _el: ElementRef
  ) {}

  ngOnInit() {
    const icon = this._loadingService.getRandomIcon();
    this.iconHtml = this._sanitizer.bypassSecurityTrustHtml(icon.svg);
    this.iconLabel = this.label || icon.label;

    // Set CSS custom properties for dynamic color theming
    const hex = icon.color;
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);

    const host = this._el.nativeElement;
    host.style.setProperty('--accent', hex);
    host.style.setProperty('--accent-bg', `rgba(${r}, ${g}, ${b}, 0.08)`);
    host.style.setProperty('--accent-bar-track', `rgba(${r}, ${g}, ${b}, 0.12)`);
    host.style.setProperty('--accent-label', `rgba(${r}, ${g}, ${b}, 0.7)`);
  }
}
